import React, { useCallback, useState } from 'react';
import logo from '../../../assets/images/logo_side_cropped.png';
import down_arrow from '../../../assets/images/down.png';
import mobile_menu from '../../../assets/images/menu.png';
import cross from '../../../assets/images/close.png';
import Button from '../../../components/designSystem/Button/Button';
import { ButtonColor } from '../../../components/designSystem/Button/Button.types';
import '../../../styles/Menu.css';
import MenuTypes from './Menu.types';
import { useCurrentUser } from '../../../hooks/useCurrentUser/useCurrentUser';
import { signOut } from '../../../store/authentication/authenticationActions/authenticationActions';
import { useQueryClient } from 'react-query';
import { useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import ChooseLoginModal from './ChooseLoginModal/ChooseLoginModal';
import ChooseRegisterModal from './ChooseRegisterModal/ChooseRegisterModal';
import { UserRoles } from '../../../types/models/user/user.types';

export default () => {
  const currentUser = useCurrentUser();

  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const submenus = MenuTypes('OFFLINE');
  const [isMobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isRegisterModalOpen, setRegisterModalOpen] = useState(false);

  const toggleSubMenu = (event: React.MouseEvent<HTMLLIElement>) => {
    const target = event.currentTarget.querySelector('ul');
    if (target) {
      target.classList.toggle('submenu-open');
    }
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!isMobileMenuOpen);
  };

  const CurrentActionButton = useCallback(() => {
    if (currentUser) {
      const isStepableAccount = [UserRoles.AcheteurPublic, UserRoles.Entreprise].includes(
        currentUser.role
      );
      if (isStepableAccount) {
        if (currentUser.role === UserRoles.AcheteurPublic) {
          if (currentUser.id_step === 4) {
            return (
              <Link to="/dashboard">
                <Button color={ButtonColor.Contrast} style={{ alignSelf: 'center' }}>
                  Tableau de bord
                </Button>
              </Link>
            );
          } else {
            return (
              <Link to="/step_wizard/ENT">
                <Button color={ButtonColor.Contrast} style={{ alignSelf: 'center' }}>
                  Mon compte
                </Button>
              </Link>
            );
          }
        } else if (currentUser.role === UserRoles.Entreprise) {
          if (currentUser.id_step === 3) {
            return (
              <Link to="/dashboard">
                <Button color={ButtonColor.Contrast} style={{ alignSelf: 'center' }}>
                  Tableau de bord
                </Button>
              </Link>
            );
          } else {
            return (
              <Link to="/step_wizard/ENT">
                <Button color={ButtonColor.Contrast} style={{ alignSelf: 'center' }}>
                  Mon compte
                </Button>
              </Link>
            );
          }
        } else {
          return null;
        }
      } else {
        return (
          <Link to="/dashboard">
            <Button color={ButtonColor.Contrast} style={{ alignSelf: 'center' }}>
              Tableau de bord
            </Button>
          </Link>
        );
      }
    } else {
      return null;
    }
  }, [currentUser]);

  return (
    <>
      <header className="header__menuLayer">
        <div className="header__menuLayerMenu">
          <a href="/">
            <img className="header__menuLayerMenu__logo" src={logo} alt="Logo" />
          </a>
          <ul className="header__menuLayerMenuBox">
            {/* <li className="header__menuLayerMenuBoxItem__target__active">Accueil</li> */}
            {Object.keys(submenus).map((submenuKey, index) =>
              submenus[submenuKey].length > 1 ? (
                <li
                  className="header__menuLayerMenuBoxItem__submenu"
                  key={index}
                  onClick={toggleSubMenu}>
                  {submenuKey}{' '}
                  {submenus[submenuKey].length > 1 && (
                    <img src={down_arrow} width={20} alt="Arrow" />
                  )}
                  <ul className="submenu">
                    {submenus[submenuKey].map((item, itemIndex) => (
                      <li key={itemIndex}>
                        <a href={item.link} title={item.title}>
                          {item.title}
                        </a>
                      </li>
                    ))}
                  </ul>
                </li>
              ) : (
                <li className="header__menuLayerMenuBoxItem__target" key={index}>
                  {submenus[submenuKey].map((item, itemIndex) => (
                    <a key={itemIndex} href={item.link} title={item.title}>
                      {item.title}
                    </a>
                  ))}
                </li>
              )
            )}
          </ul>

          <ul className="header__menuLayerMenuBoxLogin">
            {currentUser ? (
              <div className="flex-row align-center" style={{ columnGap: 16 }}>
                <span>
                  Bienvenue{' '}
                  <strong>
                    {currentUser.firstName} {currentUser.lastName}
                  </strong>
                </span>
                <li>
                  <CurrentActionButton />
                  <Link to="/login">
                    <Button
                      color={ButtonColor.Primary}
                      style={{ alignSelf: 'center' }}
                      onClick={() => {
                        signOut(queryClient)(dispatch).then(() => navigate('/'));
                      }}>
                      Se déconnecter
                    </Button>
                  </Link>
                </li>
              </div>
            ) : (
              <>
                <li>
                  <Link to="/login/entreprise">
                    <Button
                      color={ButtonColor.Contrast}
                      style={{ alignSelf: 'center' }}
                      // onClick={() => setLoginModalOpen(true)}
                    >
                      Connexion
                    </Button>
                  </Link>
                </li>
                <li>
                  <Link to="/step_wizard/ENT">
                    <Button
                      color={ButtonColor.Primary}
                      style={{ alignSelf: 'center' }}
                      // onClick={() => setRegisterModalOpen(true)}
                    >
                      Inscrivez-vous !
                    </Button>
                  </Link>
                </li>
              </>
            )}
            {/* <li><a href="/login"><Button color={ButtonColor.Primary} style={{ alignSelf: 'center' }}>Connexion</Button></a></li> */}
            {/* <li style={{ display: 'none' }}>
						<a href="#"><Button style={{ alignSelf: 'center' }}>Inscrivez-vous !</Button></a>
					</li> */}
          </ul>

          <div className="header__menuLayerMenuBoxMobile">
            <img
              className="header__menuLayerMenuBoxMobile__trigger"
              src={mobile_menu}
              alt="Mobile Menu Trigger"
              onClick={toggleMobileMenu}
            />
            <ul
              className={`header__menuLayerMenuBoxMobile__content ${
                isMobileMenuOpen ? 'mobile-menu-open' : ''
              }`}>
              <img
                className="header__menuLayerMenuBoxMobile__contentClose"
                src={cross}
                alt="Mobile Menu Close"
                onClick={toggleMobileMenu}
              />
              {/* <li className="header__menuLayerMenuBoxItem__target__active">
                <a href="/">Accueil</a>
              </li> */}

              {Object.keys(submenus).map((submenuKey, index) =>
                submenus[submenuKey].length > 1 ? (
                  <li
                    className="header__menuLayerMenuBoxMobileItem__submenu"
                    key={index}
                    onClick={toggleSubMenu}>
                    {submenuKey}{' '}
                    {submenus[submenuKey].length > 1 && (
                      <img src={down_arrow} width={20} alt="Arrow" />
                    )}
                    <ul className="submenu">
                      {submenus[submenuKey].map((item, itemIndex) => (
                        <li key={itemIndex}>
                          <a href={item.link} title={item.title}>
                            {item.title}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </li>
                ) : (
                  <li className="header__menuLayerMenuBoxItem__target" key={index}>
                    {submenus[submenuKey].map((item, itemIndex) => (
                      <Button key={itemIndex}>{item.title}</Button>
                    ))}
                  </li>
                )
              )}

              <li>
                {currentUser ? (
                  `Bienvenue ${currentUser.firstName} ${currentUser.lastName}`
                ) : (
                  <Link to="/login/entreprise">
                    <Button 
                      color={ButtonColor.Primary} style={{ alignSelf: 'center' }} 
                      onClick={() => {
                        toggleMobileMenu()
                        setLoginModalOpen(true)
                      }}
                    >
                      Connexion
                    </Button>
                  </Link>
                )}
              </li>
              {!currentUser && 
                <Link to="/step_wizard/ENT">
                  <Button 
                    color={ButtonColor.Primary} style={{ alignSelf: 'center' }} 
                    onClick={() => {
                      toggleMobileMenu()
                      // setRegisterModalOpen(true)
                    }}
                  >
                    Inscrivez-vous
                  </Button>
                </Link>
              }
              {/* <li>
							<Button style={{ alignSelf: 'center' }}>Inscrivez-vous !</Button>
						</li> */}
            </ul>
          </div>
        </div>
      </header>
      <ChooseLoginModal isOpen={isLoginModalOpen} setOpen={setLoginModalOpen} closeOnClickOutside />
      <ChooseRegisterModal
        isOpen={isRegisterModalOpen}
        setOpen={setRegisterModalOpen}
        closeOnClickOutside
      />
    </>
  );
};
